export const categoryTypeEnums = {
    featured: "featured",
    vault: "vault"
}